class HeaderMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.innerHeader = document.querySelector('custom-header');
    this.isHover = this.innerHeader.classList.contains('on-hover');
    this.headerSection = document.querySelector('.section-header');
    this.customHeader = document.querySelector('custom-header');
  }

  connectedCallback() {
    this.button = this.querySelector('.header-mega-menu-button');
    this.content = this.querySelector('.header-mega-menu-content');

    const stickyHeaderElement = document.querySelector('sticky-header');
    if (stickyHeaderElement) stickyHeaderElement.setHeaderHeight();
    else this.style.setProperty('--header-height', `${this.innerHeader.offsetHeight}px`);

    if (window.innerWidth >= 1024) {
      this.isHover && this.button.addEventListener('mouseover', this.showMouseoverContent.bind(this));
      this.isHover && this.content.addEventListener('mouseleave', this.close.bind(this));
    }
    this.button.addEventListener('click', this.toggleContent.bind(this));
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.toggleContent.bind(this));
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  toggleContent() {
    this.customHeader.closeAllOtherMenus(this);
    this.button.classList.toggle('active');
    this.content.classList.toggle('active');
    if (this.headerSection.classList.contains('menu-active')) {
      this.headerSection.classList.add('menu-active');
    }
    this.headerSection.classList.toggle('active');
  }

  showMouseoverContent() {
    this.button.classList.add('active');
    this.content.classList.add('active');
    this.headerSection.classList.add('active');
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target) && this.content.classList.contains('active')) {
      this.close();
    }
  }

  handleScroll() {
    if (this.content.classList.contains('active')) {
      this.close();
    }
  }

  close() {
    this.button.classList.remove('active');
    this.content.classList.remove('active');
    this.headerSection.classList.remove('active');
  }
}

customElements.define('header-mega-menu', HeaderMegaMenu);
